// Core
import React from "react"
import styled from "styled-components"

import size from "../../styles/size"

function getDisplay(props) {
  const { displayFlex, displayBlock, displayInline } = props

  if (displayFlex) return "flex"
  if (displayBlock) return "block"
  if (displayInline) return "inline"

  return "flex"
}

const Container = styled.div`
  display: ${props => getDisplay(props)};
  width: 87%;
  max-width: 1280px;
  margin: auto;

  /* 630px */
  @media (max-width: ${size.laptop}) {
    flex-direction: column;
  }
`

export default function BaseContainer(props) {
  return <Container {...props}>{props.children}</Container>
}
